"use client";
import { Separator } from "@/components/ui/separator";
import React from "react";
import Image from "next/image";
import USDT from "../../public/USDT.svg";
import btc from "../../public/btcIcon.svg";
import trx from "../../public/trxIcon.svg";
import ltc from "../../public/ltcIcon.svg";
import eth from "../../public/ethIcon.svg";
import steam from "../../public/steam.svg";
import tg from "../../public/tg.svg";
import ToggleTheme from "./ToggleTheme";
import ToggleLocale from "./ToggleLocale";
import { usePathname } from "next/navigation";
import { Link } from "@/i18n/routing";
import { useTranslations } from "next-intl";
export default function Footer() {
  const t = useTranslations("footer");
  const pathname = usePathname();
  const currentPath = pathname.slice(3);
  return (
    <div
      className={`${currentPath.includes("tools") && "hidden"} shrink-0  z-[1] pt-6 sm:pt-36  w-full flex flex-col items-center`}
    >
      <div className=" w-full h-full flex flex-col py-2 sm:py-8 items-center border-t bg-background">
        <div className="flex flex-col xs:flex-row w-[92%] lg:w-[81.5%] gap-2 sm:gap-6  justify-between ">
          <div className="flex   flex-col gap-[14px]">
            <div className=" flex items-center">
              <svg
                className="mr-1  text-[#0F1C2E] dark:fill-white"
                width="32"
                height="32"
                viewBox="0 0 1634 775"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1175.48 725.392C1154.78 704.694 1154.78 671.136 1175.48 650.438L1400.73 425.184C1421.43 404.486 1421.43 370.929 1400.73 350.231L1175.48 124.976C1154.78 104.279 1154.78 70.7209 1175.48 50.0231L1209.02 16.4764C1229.72 -4.22132 1263.28 -4.22132 1283.98 16.4765L1617.73 350.231C1638.43 370.929 1638.43 404.486 1617.73 425.184L1283.98 758.939C1263.28 779.636 1229.72 779.636 1209.02 758.938L1175.48 725.392Z" />
                <path d="M458.731 125.392C479.429 104.694 479.429 71.1365 458.731 50.4387L425.184 16.892C404.486 -3.80579 370.929 -3.80579 350.231 16.892L16.4765 350.646C-4.22131 371.344 -4.22133 404.902 16.4765 425.6L350.231 759.354C370.929 780.052 404.486 780.052 425.184 759.354L458.731 725.807C479.429 705.11 479.429 671.552 458.731 650.854L233.477 425.6C212.779 404.902 212.779 371.344 233.476 350.646L458.731 125.392Z" />
                <path d="M779.231 16.892C799.929 -3.80579 833.486 -3.80579 854.184 16.892L1187.94 350.646C1208.64 371.344 1208.64 404.902 1187.94 425.6L854.184 759.354C833.486 780.052 799.929 780.052 779.231 759.354L445.476 425.6C424.779 404.902 424.779 371.344 445.476 350.646L779.231 16.892Z" />
              </svg>
              <p className="text-xl  ml-2">Steam Inventory Value</p>
            </div>
            <p className="text-base hidden  sm:block  font-normal text-slate-600 dark:text-slate-400">
              {t("subtitle1")}
              <br />
              {t("subtitle2")}
            </p>
            <div className="hidden sm:flex items-center justify-start gap-4">
              <ToggleLocale />
              <ToggleTheme />
            </div>
          </div>
          <div className="flex  w-auto  ml-auto">
            <div className="sm:text-base  text-sm">
              <p className="text-slate-600 dark:text-slate-400 font-semibold">
                {t("multichat")}
              </p>
              <div className="font-normal flex flex-col ">
                <Link href="/multichat#features" className="cursor-pointer">
                  {t("features")}
                </Link>
                <Link href="/multichat#pricing" className="cursor-pointer">
                  {t("pricing")}
                </Link>
                <Link href="/multichat#faq" className="cursor-pointer">
                  FAQ
                </Link>
              </div>
            </div>
            <div className="sm:ml-6 ml-2 font-base sm:text-base  text-sm ">
              <p className="text-slate-600 dark:text-slate-400 font-semibold">
                {t("scanner")}
              </p>
              <div className="font-normal flex flex-col ">
                <Link href="/scanner#features" className="cursor-pointer">
                  {t("features")}
                </Link>
                <Link href="/scanner#pricing" className="cursor-pointer">
                  {t("pricing")}
                </Link>
                <Link href="/scanner#faq" className="cursor-pointer">
                  FAQ
                </Link>
              </div>
            </div>
          </div>
        </div>
        <Separator className="my-6 hidden  sm:flex " />
        <div className="hidden  sm:flex   w-[92%] lg:w-[81.5%]   items-center flex-row justify-between ">
          <div className="  flex  gap-3 sm:gap-6  items-center">
            <a href="https://t.me/steaminventoryvalue" target="_blank">
              <Image
                className="dark cursor-pointer dark:invert dark:grayscale"
                alt="tg"
                src={tg}
              />
            </a>
            <a
              href="https://steamcommunity.com/groups/steaminventoryvalue"
              target="_blank"
            >
              <Image
                className="cursor-pointer dark:invert dark:grayscale"
                alt="steamico"
                src={steam}
              />
            </a>
          </div>
          <div className="   flex gap-1 xs:gap-3   items-center justify-end">
            <div className="border rounded-md border-input px-0.5 py-0.5 xs:px-2 xs:py-1">
              <Image width={16} height={16} alt="applepay" src={trx} />
            </div>
            <div className="border rounded-md border-input px-0.5 py-0.5 xs:px-2 xs:py-1">
              <Image width={16} height={16} alt="webmoneypay" src={ltc} />
            </div>
            <div className="border rounded-md border-input px-0.5 py-0.5 xs:px-2 xs:py-1">
              <Image width={16} height={16} alt="payoneerpay" src={USDT} />
            </div>
            <div className="border rounded-md border-input px-0.5 py-0.5 xs:px-2 xs:py-1">
              <Image width={16} height={16} alt="btcpay" src={btc} />
            </div>
            <div className="border rounded-md border-input px-0.5 py-0.5 xs:px-2 xs:py-1">
              <Image width={16} height={16} alt="ethpay" src={eth} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
